<template>
  <div v-if="buildingOwner">
    <span
      :class="
        mandateCurrentTantiemes > 0 ? 'text-dark font-weight-bold' : 'text-muted font-weight-light'
      "
    >
      {{ buildingOwner.name }}
    </span>
  </div>
</template>

<script>
import MeetingDetailsMixin from "@/mixins/meeting-details";
export default {
  mixins: [MeetingDetailsMixin],
  props: {
    buildingOwnerId: {
      type: String,
      required: true,
    },
    mandateCurrentTantiemes: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      buildingOwner: null,
    };
  },
  created() {
    this.buildingOwner = this.findBuildingOwner(this.buildingOwnerId);
  },
};
</script>
